<template>
<div id="app" :key="key">
    <transition :key="key">
        <router-view></router-view>
    </transition>
</div>
</template>

<script>
/*import Vue from 'vue'
Vue.use(vant);*/
import Cookies from 'js-cookie'
import {
    mapState
} from "vuex";
export default {
    name: 'app',
    components: {
        ...mapState(["adminLogin"]),
    },
    computed: {
        key() {
            return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
        }
    },
    mounted() {

        let router = this.$route
        // console.log(router)
        //         // 先检查sessionStorage中是否有数据，若存在数据则加载到vuex
        let newpar = /([a-zA-Z]+)-([0-9]+)/
           
            if (newpar.test(router.fullPath) && router.name != 'special_detail' && router.name != 'org_detail' && router.name != 'meeting_detail'&&!('sa-request-id' in router.query)) {
                let arr = router.fullPath.split('/')
                window.location.href = window.location.protocol + '//' + window.location.host + ('/org_detail/' + 'JG' + ((arr[arr.length - 1] == '') ? arr[arr.length - 2] : arr[arr.length - 1]).split('-')[1])
            }
        let redirectedFrom = router.fullPath;
        if (router.fullPath && router.name != 'special_detail' && router.name != 'org_detail' && router.name != 'meeting_detail') {
            let arr = redirectedFrom.split('/')
            let test1 = redirectedFrom.indexOf('PMH')
            let test2 = redirectedFrom.indexOf('PZ')
            let test3 = redirectedFrom.indexOf('sendInfor.php')
            let test4 = redirectedFrom.indexOf('showpic.php')
            let test5 = redirectedFrom.indexOf('morenews.php')
            if (test1 != -1 && test2 != -1) {
                window.location.href = window.location.protocol + '//' + window.location.host + ('/special_detail/' + ((arr[arr.length - 1] == '') ? arr[arr.length - 2] : arr[arr.length - 1]))
            } else if (test1 != -1) {
                window.location.href = window.location.protocol + '//' + window.location.host + ('/meeting_detail/' + ((arr[arr.length - 1] == '') ? arr[arr.length - 2] : arr[arr.length - 1]))
            }
            if (test3 != -1) {
                window.location.href = window.location.protocol + '//' + window.location.host + '/sendInfor'
            }
            if (test4 != -1) {
                let arrPro = location.href.split('=')
                window.location.href = window.location.protocol + '//' + window.location.host + '/paimai-' + arrPro[1]
            }
            if (test5 != -1) {
                let arrPro = location.href.split('=')
                window.location.href = window.location.protocol + '//' + window.location.host + '/morenews/' + arrPro[1]
            }
        }

        let fromLink = this.$route.query.from ? '?from=' + this.$route.query.from : ''
        if (/Android|webOS|ios|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
            switch (router.name) {
                case 'home':
                    window.location.href = 'https://m-auction.artron.net/'
                    break
                case 'meeting_detail':
                    window.location.href = 'https://m-auction.artron.net/session/' + router.params.id + fromLink
                    break
                case 'special_detail':
                    window.location.href = 'https://m-auction.artron.net/special/' + router.params.id + fromLink
                    break
                case 'org_detail':
                    window.location.href = 'https://m-auction.artron.net/organ/' + router.params.id
                    break
                case 'product_detail':
                    window.location.href = 'https://m-auction.artron.net/productdetail/' + router.params.id + fromLink
                    break
                case 'result_meeting':
                    window.location.href = 'https://m-auction.artron.net/preview?active=1'
                    break
                case 'preview_meeting':
                    window.location.href = 'https://m-auction.artron.net/preview'
                    break
            }
        }
        //在页面刷新时将vuex里的信息保存到sessionStorage里
        if (typeof window !== 'undefined') {
            window.addEventListener("beforeunload", () => {
                window.sessionStorage.setItem("store", JSON.stringify(this.$store.state));
            });
        }
        // 后台管理name
        const adminName = ['logo', 'adminiStrator', 'announcement', 'focusMap', 'focusMapAdd', 'userServices', 'specialFeatures', 'specialFeaturesAdd', 'previewBoutique', 'previewBoutiqueAdd', 'transactionBoutique', 'transactionBoutiqueAdd', 'specialManagement', 'collectionManagement', 'collectionManagementAdd', 'shootingManagement', 'shootingManagementAdd', 'companyProfile', 'contactPage', 'physicalStoreDisplay', 'physicalStoreDisplayAdd', 'institutionalFramework', 'branchOffice', 'consultingFeedback', 'displaySettings']
        if(Cookies.get('state_login')){
             this.$store.commit("setAdminLoginInfo",JSON.parse(Cookies.get('state_login')));
             this.$forceUpdate()
        }
        if (typeof window !== 'undefined') {
            if (window.sessionStorage.getItem("store")) {
                this.$store.replaceState(
                    Object.assign({},
                        this.$store.state,
                        JSON.parse(window.sessionStorage.getItem("store"))
                    )
                );
                window.sessionStorage.removeItem("store");
                this.$forceUpdate()
            }
            let indexStr = false
            for (let i in adminName) {
                if (this.$route.path.indexOf(adminName[i]) !== -1) {

                    indexStr = true
                }
            }
            

            const state = this.$store.state.adminLogin.zone_info? this.$store.state.adminLogin.zone_info.organ_id :''
            if (state=='' && indexStr) {
                Cookies.remove('state_login');
                this.$router.push("/admin/login");
                this.$message.error('请登陆之后再访问后台管理页面')
            }
        }
    }
}
</script>

<style lang="scss">
#app {
    font-family: 'Microsoft YaHei', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
}

body,
html {
    font-size: 14px;
    height: 100%;
}

* {
    padding: 0;
    margin: 0;
    /* max-width:100%; */
}

input {
    border: none;
    outline: none;
    /*清除移动端默认的表单样式*/
    -webkit-appearance: none;
}

ul,
ol {
    list-style: none;
}

.f_left {
    float: left;
}

.f_right {
    float: right;
}

.clearfix::before,
.clearfix::after {
    content: "";
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
}
</style>
